import { UploadCoverField } from './UploadCoverField'
import { withUploadCoverField } from './withUploadCoverField'

const ConnectedUploadCover = withUploadCoverField(UploadCoverField)

export { ConnectedUploadCover as UploadCoverField }
